import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef } from 'react';
import { ButtonBase } from '../common/preflighted';
import { useTheme } from '../common/providers/DialectThemeProvider';
export default forwardRef(function IconButton(props, ref) {
    const { iconButton } = useTheme();
    return (_jsx("div", { className: clsx('dt-relative', props.className), style: props.style, children: _jsx(ButtonBase, { ref: ref, className: iconButton, onClick: (event) => {
                var _a;
                event.preventDefault();
                (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
            }, children: props.icon }) }));
});
//# sourceMappingURL=index.js.map